import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../assets/images/Logo_Ambitus.png'
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';


function Navbars() {

  const { t } = useTranslation();


  return (
    <>
    <Navbar  expand="lg" variant="light" className='nav_custom'  sticky='top'>
      <Container >
        <Navbar.Brand href="#">
          <img src={logo} alt='Ambitus Strategy'
            className='adjust-img1'
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav
            className="me-auto my-2 my-lg-0 "
            style={{ maxHeight: '100px' }}
            navbarScroll
          >
            <Nav.Link className='navlinkNormal white' href="#About">{t('nav.about')}</Nav.Link>
            <Nav.Link className='navlinkNormal white' href="#Projects">{t('nav.projects')}</Nav.Link>
            <Nav.Link className='navlinkNormal white' href="#Applications">{t('nav.applications')}</Nav.Link>
            <Nav.Link className='navlinkNormal white' href="#Advantages">{t('nav.advantages')}</Nav.Link>
          </Nav>

          <LanguageSwitcher className="navbar-language-switcher" />

          <div className='nest-button '>
          <Nav.Link href="#Contact" >
            {t('nav.contact')}
            </Nav.Link>
          </div>
        </Navbar.Collapse>
    
      </Container>
      
    </Navbar>
   

                     
    </>
  );
}

export default Navbars;
